var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1210_1024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00341797,
    y: 0.530273,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1210_1024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0034 12.5303C10.9034 12.5303 9.96175 12.1386 9.17842 11.3553C8.39508 10.5719 8.00342 9.63027 8.00342 8.53027C8.00342 7.43027 8.39508 6.48861 9.17842 5.70527C9.96175 4.92194 10.9034 4.53027 12.0034 4.53027C13.1034 4.53027 14.0451 4.92194 14.8284 5.70527C15.6118 6.48861 16.0034 7.43027 16.0034 8.53027C16.0034 9.63027 15.6118 10.5719 14.8284 11.3553C14.0451 12.1386 13.1034 12.5303 12.0034 12.5303ZM4.00342 20.5303V17.7303C4.00342 17.1636 4.14925 16.6428 4.44092 16.1678C4.73258 15.6928 5.12008 15.3303 5.60342 15.0803C6.63675 14.5636 7.68675 14.1761 8.75342 13.9178C9.82008 13.6594 10.9034 13.5303 12.0034 13.5303C13.1034 13.5303 14.1868 13.6594 15.2534 13.9178C16.3201 14.1761 17.3701 14.5636 18.4034 15.0803C18.8868 15.3303 19.2743 15.6928 19.5659 16.1678C19.8576 16.6428 20.0034 17.1636 20.0034 17.7303V20.5303H4.00342ZM6.00342 18.5303H18.0034V17.7303C18.0034 17.5469 17.9576 17.3803 17.8659 17.2303C17.7743 17.0803 17.6534 16.9636 17.5034 16.8803C16.6034 16.4303 15.6951 16.0928 14.7784 15.8678C13.8618 15.6428 12.9368 15.5303 12.0034 15.5303C11.0701 15.5303 10.1451 15.6428 9.22842 15.8678C8.31175 16.0928 7.40342 16.4303 6.50342 16.8803C6.35342 16.9636 6.23258 17.0803 6.14092 17.2303C6.04925 17.3803 6.00342 17.5469 6.00342 17.7303V18.5303ZM12.0034 10.5303C12.5534 10.5303 13.0243 10.3344 13.4159 9.94277C13.8076 9.55111 14.0034 9.08027 14.0034 8.53027C14.0034 7.98027 13.8076 7.50944 13.4159 7.11777C13.0243 6.72611 12.5534 6.53027 12.0034 6.53027C11.4534 6.53027 10.9826 6.72611 10.5909 7.11777C10.1993 7.50944 10.0034 7.98027 10.0034 8.53027C10.0034 9.08027 10.1993 9.55111 10.5909 9.94277C10.9826 10.3344 11.4534 10.5303 12.0034 10.5303Z",
    fill: "#05294F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.26343e0e992865016a485fdb391a2ea7.svg";
export { ForwardRef as ReactComponent };